import { ErroDeApi } from '@/api/clients/criarCliente'
import { mensagemDoErro } from '@/components/erros'

import { TEXTOS } from './textos'

/**
 * O job foi ACEITO (202) e não terminou em resposta: status `falha`, teto de
 * espera, corpo ilegível, 404 no polling.
 *
 * Carrega o `idConversa` porque a conversa existe no servidor mesmo quando a
 * mensagem falhou — a próxima pergunta continua nela.
 */
export class FalhaDoAssistente extends Error {
  readonly idConversa: string

  constructor(mensagem: string, idConversa: string) {
    super(mensagem)
    this.name = 'FalhaDoAssistente'
    this.idConversa = idConversa
  }
}

export interface Aviso {
  tom: 'atencao' | 'perigo'
  texto: string
}

/**
 * O que o painel mostra para um envio que não deu certo.
 *
 * 429 é um ESTADO explicado, e não um erro (épico AC-4): tom de atenção e um texto
 * que diz o que fazer. Todo o resto mostra a mensagem que o servidor mandou.
 */
export function avisoDoErro(erro: unknown): Aviso {
  if (erro instanceof ErroDeApi && erro.status === 429) {
    return { tom: 'atencao', texto: TEXTOS.limite }
  }
  if (erro instanceof FalhaDoAssistente) return { tom: 'perigo', texto: erro.message }
  return { tom: 'perigo', texto: mensagemDoErro(erro) }
}
